import Hades from '@adoratorio/hades';
import { isTouchDevice } from '@/scripts/utils';

const hades = {
  ref: null,

  init() {
    hades.ref = new Hades({
      viewport: document.querySelector('.app'),
      container: document.querySelector('.view-container'),
      easing: {
        mode: isTouchDevice() ? Hades.EASING.QUAD : Hades.EASING.CUBIC,
        duration: isTouchDevice() ? 400 : 200,
      },
      touchMultiplier: 2.5,
      scrollbar: null,
    });
  },
};

export default hades;
